import React, { useState } from 'react';
import { ErrorMessage, Field, Form, Formik } from 'formik';
import Select, { createFilter } from 'react-select';
import Input from '../../../common/form-elements/input/input';
import FormErrorMessage from '../../../common/form-elements/form-error-message/form-error-message';
/* Validations */
import { maxLength, minLength, required, schemaValidate } from '../../../../helpers/validation-helpers';
import { addColorOptions } from '../../../../helpers/util';

import {
    TASK_LIST_CONFIG_WIDGET_TITLE_PLACEHOLDER,
    TASK_LIST_CONFIG_PLACEHOLDER_ALL,
    TASK_PRIORITIES,
    TASK_STATUSES,
    TASK_LIST_CONFIG_ASSIGNED_TO_LABEL,
    TASK_LIST_CONFIG_PRIORITY_LABEL,
    TASK_LIST_CONFIG_STATUS_LABEL,
    TASK_LIST_CONFIG_CREATOR_LABEL
} from './constants';

const statusOptions = addColorOptions(TASK_STATUSES);

const TaskListConfigForm = ({
    initialValues,
    onCancel,
    onFormSubmit,
    userOptions
}) => {
    const [configUserOptions] = useState([{ label: 'All', value: '' }, ...userOptions]);

    const customStyles = {
        multiValue: (styles, { data }) => {
            return {
                ...styles,
                backgroundColor: data.color,
                color: 'white',
                padding: '4px 0 4px 10px',
                borderRadius: '8px'
            };
        },
        multiValueLabel: () => ({
            color: 'white',
            fontSize: '12px',
            lineHeight: '15px'
        }),
        multiValueRemove: styles => ({
            ...styles,
            ':hover': {
                backgroundColor: 'inherit !important'
            }
        })
    };

    const handleFormSelectChange = (props, field) => value => {
        props.setFieldValue(field, value);
    };

    const handleSubmit = values => onFormSubmit(values);

    return (
        <Formik
            initialValues={initialValues}
            onSubmit={handleSubmit}
        >
            {(props) => {
                return (
                    <Form>
                        <div className="glu-modal__body">
                            <div className="glu-content__section">
                                <div className="glu-form-row">
                                    <div className="glu-label">Widget Title</div>
                                    <Field
                                        as={Input}
                                        name="title"
                                        className="glu-form-input-pad"
                                        autoFocus
                                        placeholder={TASK_LIST_CONFIG_WIDGET_TITLE_PLACEHOLDER}
                                        value={props.values.title}
                                        onChange={props.handleChange('title')}
                                        validate={schemaValidate(
                                            [required(), minLength(), maxLength(30)]
                                        )}
                                        invalid={
                                            props.errors.title
                                            && props.touched.title
                                        }
                                    />
                                    <ErrorMessage name="title" component={FormErrorMessage} />

                                </div>
                                <div className="glu-form-row">
                                    <div className="glu-label">Assigned to</div>
                                    <Field
                                        as={Select}
                                        name="assignedTo"
                                        placeholder={TASK_LIST_CONFIG_PLACEHOLDER_ALL}
                                        value={props.values.assignedTo}
                                        options={configUserOptions}
                                        onChange={handleFormSelectChange(props, 'assignedTo')}
                                        className="glu-select glu-form-input-pad"
                                        classNamePrefix="react-select"
                                        aria-label={TASK_LIST_CONFIG_ASSIGNED_TO_LABEL}
                                        filterOption={createFilter({
                                            matchFrom: 'any',
                                            stringify: option => `${option.label}`,
                                        })}
                                    />
                                </div>
                                <div className="glu-form-row">
                                    <div className="glu-label">Priority</div>
                                    <Field
                                        as={Select}
                                        name="priority"
                                        placeholder={TASK_LIST_CONFIG_PLACEHOLDER_ALL}
                                        value={props.values.priority}
                                        options={TASK_PRIORITIES}
                                        onChange={handleFormSelectChange(props, 'priority')}
                                        invalid={
                                            props.errors.dataType
                                            && props.touched.dataType
                                        }
                                        isMulti
                                        styles={customStyles}
                                        className="glu-select glu-form-input-pad"
                                        classNamePrefix="react-select"
                                        aria-label={TASK_LIST_CONFIG_PRIORITY_LABEL}
                                        filterOption={createFilter({
                                            matchFrom: 'any',
                                            stringify: option => `${option.label}`,
                                        })}
                                    />
                                </div>
                                <div className="glu-form-row">
                                    <div className="glu-label">Status</div>
                                    <Field
                                        as={Select}
                                        name="status"
                                        placeholder={TASK_LIST_CONFIG_PLACEHOLDER_ALL}
                                        value={props.values.status}
                                        options={statusOptions}
                                        invalid={
                                            props.errors.dataProperty
                                            && props.touched.dataProperty
                                        }
                                        isMulti
                                        styles={customStyles}
                                        onChange={handleFormSelectChange(props, 'status')}
                                        className="glu-select glu-form-input-pad"
                                        classNamePrefix="react-select"
                                        aria-label={TASK_LIST_CONFIG_STATUS_LABEL}
                                        filterOption={createFilter({
                                            matchFrom: 'any',
                                            stringify: option => `${option.label}`,
                                        })}
                                    />
                                </div>
                                <div className="glu-form-row">
                                    <div className="glu-label">Creator</div>
                                    <Field
                                        as={Select}
                                        name="creator"
                                        placeholder={TASK_LIST_CONFIG_PLACEHOLDER_ALL}
                                        value={props.values.creator}
                                        options={configUserOptions}
                                        onChange={handleFormSelectChange(props, 'creator')}
                                        className="glu-select glu-form-input-pad"
                                        classNamePrefix="react-select"
                                        aria-label={TASK_LIST_CONFIG_CREATOR_LABEL}
                                        filterOption={createFilter({
                                            matchFrom: 'any',
                                            stringify: option => `${option.label}`,
                                        })}
                                    />
                                </div>
                            </div>
                        </div>

                        <footer className="glu-modal__footer">
                            <div className="glu-flex-grow glu-flex-row">
                                <div className="glu-flex-grow text-right">
                                    <button
                                        onClick={onCancel}
                                        className="glu-btn glu-btn--secondary"
                                        type="button"
                                    >
                                        Cancel
                                    </button>
                                </div>
                                <div className="glu-flex-shrink">
                                    <button
                                        className="glu-btn glu-btn--primary"
                                        type="submit"
                                    >
                                        Save
                                    </button>
                                </div>
                            </div>
                        </footer>
                    </Form>
                );
            }}
        </Formik>
    );
};

export default TaskListConfigForm;
